import { ContentLayout, HeaderBreadcrumbs, CustomTable } from "../../../shared";
import * as React from "react";
import {
  Button,
  Stack,
  Typography,
  Card,
  Grid,
  TextField,
  Divider,
  Box,
  FormHelperText,
  Tab,
} from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
import InputControl from "../../../shared/components/InputControl";
import SimpleReactValidator from "simple-react-validator";
import { useList } from "../hooks";
import { TabContext, TabList, TabPanel } from "@mui/lab";

export const UploadList = () => {
  const { id } = useParams();
  const location = useLocation();
  const isStoreAdmin = location.pathname.includes("/store-admin");

  const {
    state,
    storeList,
    globalData,
    handleInputChange,
    handleUploadExcel,
    handleInputChangeFile,
    handleUpdateUploadExcel,
    setCurentTab,
    uploadHistory,
  } = useList({
    isList: false,
    detailsId: id,
    isStore: !isStoreAdmin,
  });

  const fileRef = React.useRef();
  const onLogoClick = () => {
    fileRef.current.click();
  };

  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      validators: {
        IconFormat: {
          message: "The file should be an Excel file (.xlsx or .xls)",
          rule: (val) => {
            if (val) {
              const fileName = val.name ? val.name : val;
              const extension = fileName.split(".").pop().toLowerCase();
              return ["xlsx", "xls"].includes(extension);
            }
            return false;
          },
          required: true,
        },
      },
    })
  );
  const storeOptions = storeList?.map((v) => {
    return { value: v.id, label: v.name };
  });

  const onSubmit = () => {
    if (validator.current.allValid()) {
      id ? handleUpdateUploadExcel() : handleUploadExcel();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  const handleChange = (event, newValue) => {
    setCurentTab("uploadHistory", newValue);
  };

  // cons
  //   () => [
  //     {
  //       Header: "Date & Time",
  //       accessor: "",
  //     },
  //     {
  //       Header: "User",
  //       accessor: "",
  //     },

  //     {
  //       Header: "File",
  //       accessor: "",
  //       Cell: ({ row }) => {
  //         return (
  //           <Box
  //             sx={{
  //               textDecoration: "none",
  //               cursor: "pointer",
  //               color: "blue",
  //             }}
  //           >
  //             <Link
  //               underline="none"
  //               component="button"
  //               variant="body2"
  //               // onClick={() => handlePSAndBSReportList(row?.original?.id)}
  //             >
  //               <b>Download</b>
  //             </Link>
  //           </Box>
  //         );
  //       },
  //     },
  //   ],
  //   []
  // );
  return (
    <ContentLayout
      title={"Account File Upload"}
      breadcrumbs={
        id ? (
          <>
            <HeaderBreadcrumbs
              links={[
                { name: "Dashboard", href: "/" },
                {
                  name: "Account Uploads",
                  href: isStoreAdmin ? "/store-admin/list" : "/list",
                },
                { name: "Edit" },
              ]}
            />
          </>
        ) : (
          <>
            <HeaderBreadcrumbs
              links={[
                { name: "Dashboard", href: "/" },
                {
                  name: "Account Uploads",
                  href: isStoreAdmin ? "/store-admin/list" : "/list",
                },
                { name: "create" },
              ]}
            />
          </>
        )
      }
    >
      <TabContext value={uploadHistory}>
        <Box
          className="sticky-Tab"
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            top: "88px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <TabList onChange={handleChange}>
            <Tab label="Detail" value="1" />
            {/* <Tab label="History" value="2" /> */}
          </TabList>
        </Box>
        <TabPanel sx={{ px: "0" }} value="1">
          <Card sx={{ p: "32px 24px", mb: "24px" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1" fontWeight={600}>
                  Account File Upload
                </Typography>
              </Grid>
              <Grid item sm={8}>
                <Stack width={"100%"} gap="20px">
                  <Box
                    component="a"
                    href={globalData?.pl_bs_reports?.sample_import_file}
                    sx={{
                      color: "inherit",
                      fontSize: "12px",
                      float: "right",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      fontWeight: 400,
                      ml: "auto",
                    }}
                  >
                    P&L and BS Template
                    <Box
                      component="img"
                      src="/icons/simple_download_ic.png"
                      alt="Pl&BS Template"
                    />
                  </Box>

                  {!isStoreAdmin && (
                    <InputControl
                      type="dropdown"
                      disableClearable
                      options={storeOptions ?? []}
                      getOptionLabel={(option) => option?.label}
                      value={
                        (storeOptions?.length > 0 &&
                          state?.data?.store_id &&
                          storeOptions?.find(
                            (c) => c.value === state?.data?.store_id
                          )) ||
                        null
                      }
                      onChange={(e, newValue) => {
                        handleInputChange({
                          target: {
                            name: "store_id",
                            value: newValue.value,
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Store"
                          required
                          error={validator.current.message(
                            "Store",
                            state?.data?.store_id,
                            "required"
                          )}
                          helperText={validator.current.message(
                            "Store",
                            state?.data?.store_id,
                            "required"
                          )}
                        />
                      )}
                    />
                  )}
                  <Stack direction="row" gap={1}>
                    <InputControl
                      type="dropdown"
                      options={
                        globalData?.pl_bs_reports?.pl_bs_accounts_months ?? []
                      }
                      getOptionLabel={(option) => option?.label}
                      value={
                        (globalData?.pl_bs_reports?.pl_bs_accounts_months
                          ?.length > 0 &&
                          state?.data?.month &&
                          globalData?.pl_bs_reports?.pl_bs_accounts_months?.find(
                            (c) => c.label === state?.data?.month
                          )) ||
                        null
                      }
                      onChange={(e, newValue) => {
                        handleInputChange({
                          target: {
                            name: "month",
                            value: newValue.label,
                          },
                        });
                      }}
                      sx={{
                        width: "100%",
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Month"
                          required
                          error={validator.current.message(
                            "Month",
                            state?.data?.month,
                            "required"
                          )}
                          helperText={validator.current.message(
                            "Month",
                            state?.data?.month,
                            "required"
                          )}
                        />
                      )}
                    />
                    <InputControl
                      type="dropdown"
                      disableClearable={true}
                      options={
                        globalData?.pl_bs_reports?.pl_bs_accounts_years ?? []
                      }
                      getOptionLabel={(option) => option.label}
                      value={
                        (globalData?.pl_bs_reports?.pl_bs_accounts_years
                          ?.length > 0 &&
                          state?.data?.year &&
                          globalData?.pl_bs_reports?.pl_bs_accounts_years?.find(
                            (c) => c.value === state?.data?.year
                          )) ||
                        null
                      }
                      onChange={(e, newValue) => {
                        handleInputChange({
                          target: {
                            name: "year",
                            value: newValue.value,
                          },
                        });
                      }}
                      sx={{
                        width: "100%",
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Year"
                          required
                          error={validator.current.message(
                            "Year",
                            state?.data?.year,
                            "required"
                          )}
                          helperText={validator.current.message(
                            "Year",
                            state?.data?.year,
                            "required"
                          )}
                        />
                      )}
                    />
                  </Stack>
                  <Typography variant="subtitle1" gutterBottom>
                    File*
                  </Typography>
                  <Stack
                    onClick={(e) => onLogoClick(e)}
                    sx={{
                      padding: "16px",
                      borderRadius: "8px",
                      backgroundColor: "rgba(0, 0, 0, 0.03)",
                      height: "121px",
                      border: "2px dotted rgba(0, 0, 0, 0.16)",
                    }}
                  >
                    <input
                      id="contained-button-file"
                      type="file"
                      onChange={(e) => handleInputChangeFile(e)}
                      onClick={(e) => {
                        e.target.value = null;
                      }}
                      style={{ display: "none" }}
                      ref={fileRef}
                    />
                    <Box
                      sx={{
                        border: "1px solid #E0E0E0",
                        borderRadius: "8px",
                        padding: "16px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        minHeight: "50px",
                        bgcolor: "#FFFFFF",
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        {state?.file?.name || state?.data?.excel_file ? (
                          <img
                            src="/icons/ic_files.svg"
                            style={{
                              marginRight: "4px",
                            }}
                            alt="file"
                          />
                        ) : (
                          ""
                        )}
                        <Typography
                          variant="body1"
                          sx={{
                            width: 500,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            flexGrow: 1,
                          }}
                        >
                          {state?.file?.name
                            ? state?.file?.name
                            : state?.data?.excel_file}
                        </Typography>
                      </Box>
                    </Box>
                    <Stack
                      direction="row"
                      gap={1}
                      alignContent="center"
                      mt={2}
                      alignSelf="center"
                    >
                      <Typography
                        fontWeight={400}
                        fontSize="12px"
                        color="#808080"
                      >
                        Replace,Drag & Drop Or
                      </Typography>
                      <Typography
                        fontWeight={400}
                        fontSize="12px"
                        sx={{ textDecoration: "underline", cursor: "pointer" }}
                      >
                        Upload
                      </Typography>
                      <Typography
                        fontWeight={400}
                        fontSize="12px"
                        color="#808080"
                      >
                        Excel File Here
                      </Typography>
                    </Stack>
                  </Stack>
                  <FormHelperText sx={{ color: "#C60808" }}>
                    {state?.file
                      ? validator.current.message(
                          "Excel File",
                          state?.file,
                          "required|IconFormat"
                        )
                      : validator.current.message(
                          "Excel File",
                          state?.data?.excel_file,
                          "required|IconFormat"
                        )}
                  </FormHelperText>
                </Stack>
              </Grid>
            </Grid>
            <Stack mt={3}>
              <Divider />
            </Stack>
            <Stack direction="row" justifyContent="right" mt={2}>
              <Button
                type="button"
                size="medium"
                variant="contained"
                onClick={(e) => onSubmit(e)}
                disabled={state?.isSaveButtonBusy}
              >
                Upload
              </Button>
            </Stack>
          </Card>
        </TabPanel>
        {/* <TabPanel sx={{ px: "0" }} value="2">
          <CustomTable
            columns={columns}
            data={state?.accountList}
            defaultSearch={false}
            isLoading={state?.isBusy}
            filterContent={
              <InputControl
                type="table-search"
                value={state?.searchText}
                // onChange={(e) => handleSearch(e.target.value)}
                // onClear={onSeachClear}
              />
            }
          />
        </TabPanel> */}
      </TabContext>
    </ContentLayout>
  );
};
